export default "<p>competitions works!</p>\n"